module.exports = __webpack_public_path__ + "static/media/firefox1.98038d90.png";